<template>
  <div
    class="page"
    :style="{ height: pageHeight }"
  >
    <!-- nav -->
    <div class="nav">
      <div class="nav-title">via轻插件</div>
      <div class="nav-left">
        <van-icon
          class="nav-icon"
          :size="$vw('30px')"
          class-prefix="icon"
          name="iossearch"
          @click="routerTo('Search')"
        />
        <van-icon
          class="nav-icon"
          :size="$vw('30px')"
          class-prefix="icon"
          name="iospersonadd"
          @click="routerTo('Author')"
        />
      </div>
    </div>

    <!-- swiper -->
    <div
      class="swipe-box"
      :style="{ width: $rpxToPx('345px') + 'px', height: $rpxToPx('172px') + 'px' }"
    >
      <van-swipe
        class="swipe-border-radius"
        :autoplay="3000"
        :width="$rpxToPx('345px')"
        :height="$rpxToPx('172px')"
      >
        <van-swipe-item
          v-for="item in swipeItems"
          :key="item.id"
          @click="linkTo(item.link)"
        >
          <img
            v-lazy="$imgHook(item.image)"
            style="width: 100%;"
          >
        </van-swipe-item>
      </van-swipe>
    </div>

    <recommend-card
      class="card"
      title="推荐插件"
      type="plugin"
      :data="recommendPlugins"
    />
    <recommend-card
      class="card"
      title="最新插件"
      type="plugin"
      :data="newPlugins"
    />
    <recommend-card
      class="card"
      title="更新插件"
      type="plugin"
      :data="updatePlugins"
    />

    <recommend-card
      class="card"
      title="最新主页"
      type="homePage"
      :data="newHomePages"
    />
    <recommend-card
      class="card"
      title="最新文章"
      type="article"
      :data="newArticles"
    />

    <div class="blank-bottom" />
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant'
import RecommendCard from 'components/home/recommendCard.vue'

export default {
  name: 'Home',
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [RecommendCard.name]: RecommendCard
  },
  data() {
    return {
      swipeItems: [],
      tags: [],
      recommendArticles: [],
      recommendPlugins: [],
      recommendHomePages: [],
      newArticles: [],
      newPlugins: [],
      newHomePages: [],
      updateArticles: [],
      updatePlugins: [],
      updateHomePages: []
    }
  },
  computed: {
    pageHeight() {
      const tabbarHeight = this.$rpxToPx(60)
      return this.$pxToVw(this.$clientHeight - tabbarHeight) + 'vw'
    }
  },
  watch: {
    // 首页数据
    '$store.state.home.homeConfig'(newValue, oldValue) {
      this.updateData(newValue)
    }
  },
  activated() {
    this.updateData(this.$store.getters['home/homeConfig'])
  },
  methods: {
    updateData(homeConfig) {
      if (!homeConfig) {
        return
      }
      const {
        swipeItems,
        tags,
        recommendArticles,
        recommendPlugins,
        recommendHomePages,
        newArticles,
        newPlugins,
        newHomePages,
        updateArticles,
        updatePlugins,
        updateHomePages } = homeConfig
      this.swipeItems = swipeItems
      this.tags = tags
      this.recommendArticles = recommendArticles
      this.recommendPlugins = recommendPlugins
      this.recommendHomePages = recommendHomePages
      this.newArticles = newArticles
      this.newPlugins = newPlugins
      this.newHomePages = newHomePages
      this.updateArticles = updateArticles
      this.updatePlugins = updatePlugins
      this.updateHomePages = updateHomePages
    },
    routerTo(name) {
      this.$router.$push({
        name
      })
    },
    goToPluginDetail(id) {
      this.$router.$push({
        name: 'PluginDetail',
        params: {
          id
        }
      })
    },
    linkTo(url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.page {
  width: 375px;
  overflow-x: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
/* nav */
.nav {
  width: 375px;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
}
.nav-title {
  font-size: 30px;
  font-weight: 900;
  margin-left: 15px;
}
.nav-left {
  width: 30%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 15px;
}
.nav-left > .nav-icon {
  margin-left: 8px;
}

/* .swipe */
.swipe-box {
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 15px;
  margin: 15px 15px 0 15px;
  box-shadow: var(--boxShadow-bottom);
}
.swipe-border-radius {
  border-radius: 15px;
}
.card {
  margin-top: 40px;
}
.blank-bottom {
  width: 375px;
  height: 30px;
}
</style>
